import CryptoJS from "crypto-js";

const secretKey = process.env.REACT_APP_API_SECRET_KEY;

function createKey(secret) {
  if (!secret) {
    throw new Error("REACT_APP_API_SECRET_KEY is not configured");
  }

  return CryptoJS.SHA256(secret)
    .toString(CryptoJS.enc.Hex)
    .substring(0, 32);
}

export function encryptData(data) {
  const key = createKey(secretKey);
  const iv = CryptoJS.lib.WordArray.random(16);

  const plainText =
    typeof data === "string" ? data : JSON.stringify(data);

  const encrypted = CryptoJS.AES.encrypt(
    plainText,
    CryptoJS.enc.Utf8.parse(key),
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  return `${iv.toString(CryptoJS.enc.Base64)}:${encrypted.toString()}`;
}